import React, { useCallback, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { action } from 'mobx';
import { $l } from '../locale-context';
import TableContext from './TableContext';
import Tooltip from '../tooltip';
import Button from '../button/Button';
import { FuncType } from '../button/enum';
const SelectionTips = observer(function SelectionTips() {
    const { prefixCls, dataSet, tableStore, showSelectionCachedButton, onShowCachedSelectionChange } = useContext(TableContext);
    const { showCachedSelection } = tableStore;
    const handleSwitch = useCallback(action(() => {
        const newShowCachedSelection = !showCachedSelection;
        tableStore.showCachedSelection = newShowCachedSelection;
        if (onShowCachedSelectionChange) {
            onShowCachedSelectionChange(newShowCachedSelection);
        }
    }), [showCachedSelection, onShowCachedSelectionChange]);
    const cachedButton = showSelectionCachedButton && dataSet.cacheSelectionKeys && dataSet.cachedSelected.length > 0 ? (React.createElement(Tooltip, { title: $l('Table', showCachedSelection ? 'hide_cached_seletion' : 'show_cached_seletion') },
        React.createElement(Button, { className: `${prefixCls}-switch`, funcType: FuncType.flat, icon: showCachedSelection ? 'visibility_off' : 'visibility', onClick: handleSwitch }))) : null;
    return tableStore.showSelectionTips ? (React.createElement("div", { className: `${prefixCls}-selection-tips` },
        React.createElement("span", null, $l('Table', 'selection_tips', { count: React.createElement("b", null, dataSet.selected.length) })),
        cachedButton)) : cachedButton;
});
SelectionTips.displayName = 'SelectionTips';
export default SelectionTips;
